<template>
    <div class="corps_wrap">
        <img src="../../assets/corps/corps_bg.jpg" alt />
        <!-- 四个上面导航栏 -->
        <div class="tab">
            <img src="../../assets/corps/qixie.png" alt v-show="crops=='qixie'" />
            <img src="../../assets/corps/cheqi.png" alt v-show="crops=='cheqi'" />
            <img src="../../assets/corps/bubing.png" alt v-show="crops=='bubing'" />
            <img src="../../assets/corps/gongnu.png" alt v-show="crops=='gongnu'" />
            <ul>
                <li @click="handleTab('qixie')"></li>
                <li @click="handleTab('cheqi')"></li>
                <li @click="handleTab('bubing')"></li>
                <li @click="handleTab('gongnu')"></li>
            </ul>
            <!-- 兵种中间内容图 -->
            <div class="content all_content">
                <div class="qixie" v-if="selectedBigTab == 'qixie'">
                    <div v-for="(item,index) in qixinCropsList"
                        :key="item.id"
                        :class="item.name"
                    >
                        <img :src="item.imgSrc"  v-show="selectedSmallTab == index" class="animate__animated animate__flipInX" />
                    </div>
                </div>
                <div class="cheqi" v-if="selectedBigTab == 'cheqi'">
                    <div v-for="(item,index) in cheqiCropsList"
                        :key="item.id"
                        :class="item.name"
                    >
                        <img :src="item.imgSrc" v-show="selectedSmallTab == index" class="animate__animated animate__flipInX" />
                    </div>
                </div>
                <div class="bubing" v-if="selectedBigTab == 'bubing'">
                    <div v-for="(item,index) in bubingCropsList"
                        :key="item.id"
                        :class="item.name"
                    >
                        <img :src="item.imgSrc" v-show="selectedSmallTab == index" class="animate__animated animate__flipInX" />
                    </div>
                </div>
                <div class="gongnu" v-if="selectedBigTab == 'gongnu'">
                    <div v-for="(item,index) in gongnuCropsList"
                        :key="item.id"
                        :class="item.name"
                    >
                        <img :src="item.imgSrc" v-show="selectedSmallTab == index" class="animate__animated animate__flipInX" />
                    </div>
                </div>
            </div>
            <!-- 兵种下面一排导航 -->
            <div class="nav">
                <div class="qixie" v-if="selectedBigTab == 'qixie'">
                    <img src="../../assets/corps/qixie/crops_tab.png" alt />
                    <div class="content">
                        <a
                            href="javascript:;"
                            v-for="(item,index) in qixinCropsList"
                            :key="item.id"
                            :class="{
                            c:selectedName == item.name,
                            c1:selectedName == item.name && index==0,
                            c2:selectedName == item.name && index==1,
                            c3:selectedName == item.name && index==2,
                            c4:selectedName == item.name && index==3,
                            c5:selectedName == item.name && index==4,
                            c6:selectedName == item.name && index==5,
                            c7:selectedName == item.name && index==6,
                            c8:selectedName == item.name && index==7,
                            c9:selectedName == item.name && index==8
                        }"
                            @click="handleClickTabCrops(item.name,index)"
                        ></a>
                    </div>
                </div>
                <div class="cheqi" v-if="selectedBigTab == 'cheqi'">
                    <img src="../../assets/corps/cheqi/crops_tab.png" alt />
                    <div class="content">
                        <a
                            href="javascript:;"
                            v-for="(item,index) in cheqiCropsList"
                            :key="item.id"
                            :class="{
                            c:selectedName == item.name,
                            c1:selectedName == item.name && index==0,
                            c2:selectedName == item.name && index==1,
                            c3:selectedName == item.name && index==2,
                            c4:selectedName == item.name && index==3,
                            c5:selectedName == item.name && index==4,
                            c6:selectedName == item.name && index==5,
                            c7:selectedName == item.name && index==6,
                            c8:selectedName == item.name && index==7,
                            c9:selectedName == item.name && index==8,
                            c10:selectedName == item.name && index==9,
                            c11:selectedName == item.name && index==10
                        }"
                            @click="handleClickTabCrops(item.name,index)"
                        ></a>
                    </div>
                </div>
                <div class="bubing" v-if="selectedBigTab == 'bubing'">
                    <img src="../../assets/corps/bubing/crops_tab.png" alt />
                    <div class="content">
                        <a
                            href="javascript:;"
                            v-for="(item,index) in bubingCropsList"
                            :key="item.id"
                            :class="{
                            c:selectedName == item.name,
                            c1:selectedName == item.name && index==0,
                            c2:selectedName == item.name && index==1,
                            c3:selectedName == item.name && index==2,
                            c4:selectedName == item.name && index==3,
                            c5:selectedName == item.name && index==4,
                            c6:selectedName == item.name && index==5,
                            c7:selectedName == item.name && index==6,
                            c8:selectedName == item.name && index==7,
                            c9:selectedName == item.name && index==8,
                            c10:selectedName == item.name && index==9
                        }"
                            @click="handleClickTabCrops(item.name,index)"
                        ></a>
                    </div>
                </div>
                <div class="gongnu" v-if="selectedBigTab == 'gongnu'">
                    <img src="../../assets/corps/gongnu/crops_tab.png" alt />
                    <div class="content">
                        <a
                            href="javascript:;"
                            v-for="(item,index) in gongnuCropsList"
                            :key="item.id"
                            :class="{
                            c:selectedName == item.name,
                            c1:selectedName == item.name && index==0,
                            c2:selectedName == item.name && index==1,
                            c3:selectedName == item.name && index==2,
                            c4:selectedName == item.name && index==3,
                            c5:selectedName == item.name && index==4,
                            c6:selectedName == item.name && index==5,
                            c7:selectedName == item.name && index==6,
                            c8:selectedName == item.name && index==7,
                            c9:selectedName == item.name && index==8
                        }"
                            @click="handleClickTabCrops(item.name,index)"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Corps",
    props: {
        msg: String
    },
    data () {
        return {
            crops: "qixie",
            qixinCropsList: [
                {
                    id: "001",
                    name: "c1",
                    imgSrc: require("../../assets/corps/qixie/1.png")
                },
                {
                    id: "002",
                    name: "c2",
                    imgSrc: require("../../assets/corps/qixie/2.png")
                },
                {
                    id: "003",
                    name: "c3",
                    imgSrc: require("../../assets/corps/qixie/3.png")
                },
                {
                    id: "004",
                    name: "c4",
                    imgSrc: require("../../assets/corps/qixie/4.png")
                },
                {
                    id: "005",
                    name: "c5",
                    imgSrc: require("../../assets/corps/qixie/5.png")
                },
                {
                    id: "006",
                    name: "c6",
                    imgSrc: require("../../assets/corps/qixie/6.png")
                },
                {
                    id: "007",
                    name: "c7",
                    imgSrc: require("../../assets/corps/qixie/7.png")
                },
                {
                    id: "008",
                    name: "c8",
                    imgSrc: require("../../assets/corps/qixie/8.png")
                },
                {
                    id: "009",
                    name: "c9",
                    imgSrc: require("../../assets/corps/qixie/9.png")
                }
            ],
            cheqiCropsList: [
                {
                    id: "001",
                    name: "c1",
                    imgSrc: require("../../assets/corps/cheqi/1.png")
                },
                {
                    id: "002",
                    name: "c2",
                    imgSrc: require("../../assets/corps/cheqi/2.png")
                },
                {
                    id: "003",
                    name: "c3",
                    imgSrc: require("../../assets/corps/cheqi/3.png")
                },
                {
                    id: "004",
                    name: "c4",
                    imgSrc: require("../../assets/corps/cheqi/4.png")
                },
                {
                    id: "005",
                    name: "c5",
                    imgSrc: require("../../assets/corps/cheqi/5.png")
                },
                {
                    id: "006",
                    name: "c6",
                    imgSrc: require("../../assets/corps/cheqi/6.png")
                },
                {
                    id: "007",
                    name: "c7",
                    imgSrc: require("../../assets/corps/cheqi/7.png")
                },
                {
                    id: "008",
                    name: "c8",
                    imgSrc: require("../../assets/corps/cheqi/8.png")
                },
                {
                    id: "009",
                    name: "c9",
                    imgSrc: require("../../assets/corps/cheqi/9.png")
                },
                {
                    id: "010",
                    name: "c10",
                    imgSrc: require("../../assets/corps/cheqi/10.png")
                },
                {
                    id: "011",
                    name: "c11",
                    imgSrc: require("../../assets/corps/cheqi/11.png")
                }
            ],
            bubingCropsList: [
                {
                    id: "001",
                    name: "c1",
                    imgSrc: require("../../assets/corps/bubing/1.png")
                },
                {
                    id: "002",
                    name: "c2",
                    imgSrc: require("../../assets/corps/bubing/2.png")
                },
                {
                    id: "003",
                    name: "c3",
                    imgSrc: require("../../assets/corps/bubing/3.png")
                },
                {
                    id: "004",
                    name: "c4",
                    imgSrc: require("../../assets/corps/bubing/4.png")
                },
                {
                    id: "005",
                    name: "c5",
                    imgSrc: require("../../assets/corps/bubing/5.png")
                },
                {
                    id: "006",
                    name: "c6",
                    imgSrc: require("../../assets/corps/bubing/6.png")
                },
                {
                    id: "007",
                    name: "c7",
                    imgSrc: require("../../assets/corps/bubing/7.png")
                },
                {
                    id: "008",
                    name: "c8",
                    imgSrc: require("../../assets/corps/bubing/8.png")
                },
                {
                    id: "009",
                    name: "c9",
                    imgSrc: require("../../assets/corps/bubing/9.png")
                },
                {
                    id: "010",
                    name: "c10",
                    imgSrc: require("../../assets/corps/bubing/10.png")
                }
            ],
            gongnuCropsList: [
                {
                    id: "001",
                    name: "c1",
                    imgSrc: require("../../assets/corps/gongnu/1.png")
                },
                {
                    id: "002",
                    name: "c2",
                    imgSrc: require("../../assets/corps/gongnu/2.png")
                },
                {
                    id: "003",
                    name: "c3",
                    imgSrc: require("../../assets/corps/gongnu/3.png")
                },
                {
                    id: "004",
                    name: "c4",
                    imgSrc: require("../../assets/corps/gongnu/4.png")
                },
                {
                    id: "005",
                    name: "c5",
                    imgSrc: require("../../assets/corps/gongnu/5.png")
                },
                {
                    id: "006",
                    name: "c6",
                    imgSrc: require("../../assets/corps/gongnu/6.png")
                },
                {
                    id: "007",
                    name: "c7",
                    imgSrc: require("../../assets/corps/gongnu/7.png")
                },
                {
                    id: "008",
                    name: "c8",
                    imgSrc: require("../../assets/corps/gongnu/8.png")
                },
                {
                    id: "009",
                    name: "c9",
                    imgSrc: require("../../assets/corps/gongnu/9.png")
                }
            ],
            selectedName: "c1",
            selectedBigTab: "qixie",
            selectedSmallTab: 0
        };
    },
    mounted () {},
    methods: {
        handleTab (n) {
            this.crops = n;
            this.selectedBigTab = n;
            this.selectedName = "c1";
            this.selectedSmallTab = 0;
        },
        handleClickTabCrops (name, index) {
            console.log(name, index);
            this.selectedName = name;
            this.selectedSmallTab = index;
        }
    }
};
</script>

<style scoped lang="scss">
.corps_wrap {
    position: relative;
    .tab {
        & > img {
            width: 8.76rem;
            height: 0.55rem;
            position: absolute;
            top: 1.8rem;
            left: 3.4rem;
            z-index: 1;
            transition: left 0.6s;
        }
        ul {
            /**display:flex;
            flex-direction: row;
            justify-content: space-between;**/
            width: 8.76rem;
            height: 0.55rem;
            position: absolute;
            z-index: 2;
            top: 1.8rem;
            left: 3.4rem;
            li {
                position: absolute;
                width: 1.88rem;
                height: 0.59rem;
                cursor: pointer;
                &:first-child {
                    left: 0;
                }
                &:nth-child(2) {
                    left: 2.26rem;
                }
                &:nth-child(3) {
                    left: 4.49rem;
                }
                &:last-child {
                    right: 0;
                }
            }
        }
        .content {
            /**width: 12.05rem;
            height: 4.33rem;**/
        }
        .all_content{
            .qixie{
                &>div{
                    position: absolute;
                    left: 3.4rem;
                }
                .c1{
                    width: 10.63rem;
                    height: 3.54rem;
                    top: 2.9rem;
                }
                .c2{
                    width: 11.86rem;
                    height: 3.18rem;
                    top: 3rem;
                }
                .c3{
                    width: 11.37rem;
                    height: 3.47rem;
                    top: 3rem;
                }
                .c4{
                    width: 10.87rem;
                    height: 3.3rem;
                    top: 3rem;
                }
                .c5{
                    width: 10.45rem;
                    height: 4.27rem;
                    top: 2.22rem;
                }
                .c6{
                    width: 11.3rem;
                    height: 3.9rem;
                    top: 2.52rem;
                }
                .c7{
                    width: 10.51rem;
                    height: 4.65rem;
                    top: 2.26rem;
                }
                .c8{
                    width: 10.45rem;
                    height: 4.3rem;
                    top: 2.3rem;
                }
                .c9{
                    width: 10.96rem;
                    height: 4.13rem;
                    top: 2.5rem;
                }
            }
        }
        .all_content{
            .cheqi{
                &>div{
                    position: absolute;
                    left: 3.4rem;
                }
                .c1{
                    width: 10.63rem;
                    height: 5.38rem;
                    top: 1.7rem;
                }
                .c2{
                    width: 9.72rem;
                    height: 5.45rem;
                    top: 1.4rem;
                }
                .c3{
                    width: 10.1rem;
                    height: 4.57rem;
                    top: 2.3rem;
                }
                .c4{
                    width: 11.67rem;
                    height: 4.93rem;
                    top: 1.9rem;
                }
                .c5{
                    width: 10.64rem;
                    height: 5.72rem;
                    top: 1.2rem;
                }
                .c6{
                    width: 9.83rem;
                    height: 4.99rem;
                    top: 1.8rem;
                }
                .c7{
                    width: 10.93rem;
                    height: 4.11rem;
                    top: 2.26rem;
                }
                .c8{
                    width: 10.91rem;
                    height: 4.2rem;
                    top: 2.7rem;
                }
                .c9{
                    width: 11.48rem;
                    height: 4.04rem;
                    top: 2.5rem;
                }
                .c10{
                    width: 10.7rem;
                    height: 2.96rem;
                    top: 2.97rem;
                }
                .c11{
                    width: 10.5rem;
                    height: 3.48rem;
                    top: 2.9rem;
                }
            }
        }
        .all_content{
            .bubing{
                &>div{
                    position: absolute;
                    left: 3.4rem;
                }
                .c1{
                    width: 10.37rem;
                    height: 4.85rem;
                    top: 2.2rem;
                }
                .c2{
                    width: 9.82rem;
                    height: 4rem;
                    top: 3.04rem;
                }
                .c3{
                    width: 9.8rem;
                    height: 3.79rem;
                    top: 2.67rem;
                }
                .c4{
                    width: 10.54rem;
                    height: 4.81rem;
                    top: 1.91rem;
                }
                .c5{
                    width: 9.71rem;
                    height: 4.75rem;
                    top: 2.2rem;
                }
                .c6{
                    width: 9.42rem;
                    height: 3.74rem;
                    top: 2.71rem;
                }
                .c7{
                    width: 9.94rem;
                    height: 5.32rem;
                    top: 1.33rem;
                }
                .c8{
                    width: 11.74rem;
                    height: 4.51rem;
                    top: 2.3rem;
                }
                .c9{
                    width: 11.33rem;
                    height: 4.6rem;
                    top: 2.35rem;
                }
                .c10{
                    width: 11.1rem;
                    height: 6.25rem;
                    top: 1rem;
                }
            }
        }
        .all_content{
            .gongnu{
                &>div{
                    position: absolute;
                    left: 3.4rem;
                }
                .c1{
                    width: 10.15rem;
                    height: 3.81rem;
                    top: 2.9rem;
                }
                .c2{
                    width: 9.49rem;
                    height: 4.28rem;
                    top: 2.5rem;
                }
                .c3{
                    width: 10.57rem;
                    height: 4.77rem;
                    top: 2.17rem;
                }
                .c4{
                    width: 11.02rem;
                    height: 5.13rem;
                    top: 2.3rem;
                }
                .c5{
                    width: 8.29rem;
                    height: 3.94rem;
                    top: 2.9rem;
                }
                .c6{
                    width: 9.34rem;
                    height: 3.67rem;
                    top: 2.81rem;
                }
                .c7{
                    width: 9.42rem;
                    height: 4.97rem;
                    top: 1.9rem;
                }
                .c8{
                    width: 9.41rem;
                    height: 4.4rem;
                    top: 2.45rem;
                }
                .c9{
                    width: 9.86rem;
                    height: 5.07rem;
                    top: 1.95rem;
                }
            }
        }
        .nav {
            .qixie {
                width: 7.79rem;
                height: 3.02rem;
                position: absolute;
                top: 7.03rem;
                left: 3.7rem;
                .content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                & > img {
                    width: 7.79rem;
                    height: 3.02rem;
                }
                a {
                    display: inline-block;
                    width: 0.88rem;
                    height: 3.03rem;
                    /**background: pink;
                    opacity: 0.6;**/
                    &.c {
                        background: url('.././../assets/corps/qixie/crops_tab_on.png')
                            no-repeat;
                        background-size: 7.79rem 3.02rem;
                        transform: scale(1.03);
                        transition: all 0.3s;
                    }
                    &.c1 {
                        background-position: -0.007rem 0;
                    }
                    &.c2 {
                        background-position: -0.87rem 0;
                    }
                    &.c3 {
                        background-position: -1.728rem 0;
                    }
                    &.c4 {
                        background-position: -2.6rem 0;
                    }
                    &.c5 {
                        background-position: -3.46rem 0;
                    }
                    &.c6 {
                        background-position: -4.33rem 0;
                    }
                    &.c7 {
                        background-position: -5.19rem 0;
                    }
                    &.c8 {
                        background-position: -6.056rem 0;
                    }
                    &.c9 {
                        background-position: -6.92rem 0;
                    }
                    &.c10 {
                        background-position: -7.78rem 0;
                    }
                    &.c11 {
                        background-position: -8.65rem 0;
                    }
                    &.c12 {
                        background-position: -9.51rem 0;
                    }
                    &:hover {
                        background: url('.././../assets/corps/qixie/crops_tab_on.png')
                            no-repeat;
                        background-size: 7.79rem 3.02rem;
                    }
                    &:nth-child(1):hover {
                        background-position: -0.007rem 0;
                    }
                    &:nth-child(2):hover {
                        background-position: -0.87rem 0;
                    }
                    &:nth-child(3):hover {
                        background-position: -1.728rem 0;
                    }
                    &:nth-child(4):hover {
                        background-position: -2.6rem 0;
                    }
                    &:nth-child(5):hover {
                        background-position: -3.46rem 0;
                    }
                    &:nth-child(6):hover {
                        background-position: -4.33rem 0;
                    }
                    &:nth-child(7):hover {
                        background-position: -5.19rem 0;
                    }
                    &:nth-child(8):hover {
                        background-position: -6.056rem 0;
                    }
                    &:nth-child(9):hover {
                        background-position: -6.92rem 0;
                    }
                    &:nth-child(10):hover {
                        background-position: -7.78rem 0;
                    }
                    &:nth-child(11):hover {
                        background-position: -8.65rem 0;
                    }
                    &:nth-child(12):hover {
                        background-position: -9.51rem 0;
                    }
                }
            }
            .cheqi {
                width: 9.52rem;
                height: 3.02rem;
                position: absolute;
                top: 7.03rem;
                left:3.7rem;
                .content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                & > img {
                    width: 9.52rem;
                    height: 3.02rem;
                }
                a {
                    display: inline-block;
                    width: 0.88rem;
                    height: 3.03rem;
                    /**background: pink;
                    opacity: 0.6;**/
                    &.c {
                        background: url('.././../assets/corps/cheqi/crops_tab_on.png')
                            no-repeat;
                        background-size: 9.52rem 3.02rem;
                        transform: scale(1.03);
                        transition: all 0.3s;
                    }
                    &.c1 {
                        background-position: -0.007rem 0;
                    }
                    &.c2 {
                        background-position: -0.87rem 0;
                    }
                    &.c3 {
                        background-position: -1.728rem 0;
                    }
                    &.c4 {
                        background-position: -2.6rem 0;
                    }
                    &.c5 {
                        background-position: -3.46rem 0;
                    }
                    &.c6 {
                        background-position: -4.33rem 0;
                    }
                    &.c7 {
                        background-position: -5.19rem 0;
                    }
                    &.c8 {
                        background-position: -6.056rem 0;
                    }
                    &.c9 {
                        background-position: -6.92rem 0;
                    }
                    &.c10 {
                        background-position: -7.78rem 0;
                    }
                    &.c11 {
                        background-position: -8.65rem 0;
                    }
                    &.c12 {
                        background-position: -9.51rem 0;
                    }
                    &:hover {
                        background: url('.././../assets/corps/cheqi/crops_tab_on.png')
                            no-repeat;
                        background-size: 9.52rem 3.02rem;
                    }
                    &:nth-child(1):hover {
                        background-position: -0.007rem 0;
                    }
                    &:nth-child(2):hover {
                        background-position: -0.87rem 0;
                    }
                    &:nth-child(3):hover {
                        background-position: -1.728rem 0;
                    }
                    &:nth-child(4):hover {
                        background-position: -2.6rem 0;
                    }
                    &:nth-child(5):hover {
                        background-position: -3.46rem 0;
                    }
                    &:nth-child(6):hover {
                        background-position: -4.33rem 0;
                    }
                    &:nth-child(7):hover {
                        background-position: -5.19rem 0;
                    }
                    &:nth-child(8):hover {
                        background-position: -6.056rem 0;
                    }
                    &:nth-child(9):hover {
                        background-position: -6.92rem 0;
                    }
                    &:nth-child(10):hover {
                        background-position: -7.78rem 0;
                    }
                    &:nth-child(11):hover {
                        background-position: -8.65rem 0;
                    }
                    &:nth-child(12):hover {
                        background-position: -9.51rem 0;
                    }
                }
            }
            .bubing {
                width: 8.65rem;
                height: 3.02rem;
                position: absolute;
                top: 7.03rem;
                left: 3.7rem;
                .content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                & > img {
                    width: 8.65rem;
                    height: 3.02rem;
                }
                a {
                    display: inline-block;
                    width: 0.88rem;
                    height: 3.03rem;
                    /**background: pink;
                    opacity: 0.6;**/
                    &.c {
                        background: url('.././../assets/corps/bubing/crops_tab_on.png')
                            no-repeat;
                        background-size: 8.65rem 3.02rem;
                        transform: scale(1.03);
                        transition: all 0.3s;
                    }
                    &.c1 {
                        background-position: -0.007rem 0;
                    }
                    &.c2 {
                        background-position: -0.87rem 0;
                    }
                    &.c3 {
                        background-position: -1.728rem 0;
                    }
                    &.c4 {
                        background-position: -2.6rem 0;
                    }
                    &.c5 {
                        background-position: -3.46rem 0;
                    }
                    &.c6 {
                        background-position: -4.33rem 0;
                    }
                    &.c7 {
                        background-position: -5.19rem 0;
                    }
                    &.c8 {
                        background-position: -6.056rem 0;
                    }
                    &.c9 {
                        background-position: -6.92rem 0;
                    }
                    &.c10 {
                        background-position: -7.78rem 0;
                    }
                    &.c11 {
                        background-position: -8.65rem 0;
                    }
                    &.c12 {
                        background-position: -9.51rem 0;
                    }
                    &:hover {
                        background: url('.././../assets/corps/bubing/crops_tab_on.png')
                            no-repeat;
                        background-size: 8.65rem 3.02rem;
                    }
                    &:nth-child(1):hover {
                        background-position: -0.007rem 0;
                    }
                    &:nth-child(2):hover {
                        background-position: -0.87rem 0;
                    }
                    &:nth-child(3):hover {
                        background-position: -1.728rem 0;
                    }
                    &:nth-child(4):hover {
                        background-position: -2.6rem 0;
                    }
                    &:nth-child(5):hover {
                        background-position: -3.46rem 0;
                    }
                    &:nth-child(6):hover {
                        background-position: -4.33rem 0;
                    }
                    &:nth-child(7):hover {
                        background-position: -5.19rem 0;
                    }
                    &:nth-child(8):hover {
                        background-position: -6.056rem 0;
                    }
                    &:nth-child(9):hover {
                        background-position: -6.92rem 0;
                    }
                    &:nth-child(10):hover {
                        background-position: -7.78rem 0;
                    }
                    &:nth-child(11):hover {
                        background-position: -8.65rem 0;
                    }
                    &:nth-child(12):hover {
                        background-position: -9.51rem 0;
                    }
                }
            }
            .gongnu {
                width: 7.79rem;
                height: 3.02rem;
                position: absolute;
                top: 7.03rem;
                left: 3.7rem;
                .content {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                & > img {
                    width: 7.79rem;
                    height: 3.02rem;
                }
                a {
                    display: inline-block;
                    width: 0.88rem;
                    height: 3.03rem;
                    /**background: pink;
                    opacity: 0.6;**/
                    &.c {
                        background: url('.././../assets/corps/gongnu/crops_tab_on.png')
                            no-repeat;
                        background-size: 7.79rem 3.02rem;
                        transform: scale(1.03);
                        transition: all 0.3s;
                    }
                    &.c1 {
                        background-position: -0.007rem 0;
                    }
                    &.c2 {
                        background-position: -0.87rem 0;
                    }
                    &.c3 {
                        background-position: -1.728rem 0;
                    }
                    &.c4 {
                        background-position: -2.6rem 0;
                    }
                    &.c5 {
                        background-position: -3.46rem 0;
                    }
                    &.c6 {
                        background-position: -4.33rem 0;
                    }
                    &.c7 {
                        background-position: -5.19rem 0;
                    }
                    &.c8 {
                        background-position: -6.056rem 0;
                    }
                    &.c9 {
                        background-position: -6.92rem 0;
                    }
                    &:hover {
                        background: url('.././../assets/corps/gongnu/crops_tab_on.png')
                            no-repeat;
                        background-size: 7.79rem 3.02rem;
                    }
                    &:nth-child(1):hover {
                        background-position: -0.007rem 0;
                    }
                    &:nth-child(2):hover {
                        background-position: -0.87rem 0;
                    }
                    &:nth-child(3):hover {
                        background-position: -1.728rem 0;
                    }
                    &:nth-child(4):hover {
                        background-position: -2.6rem 0;
                    }
                    &:nth-child(5):hover {
                        background-position: -3.46rem 0;
                    }
                    &:nth-child(6):hover {
                        background-position: -4.33rem 0;
                    }
                    &:nth-child(7):hover {
                        background-position: -5.19rem 0;
                    }
                    &:nth-child(8):hover {
                        background-position: -6.056rem 0;
                    }
                    &:nth-child(9):hover {
                        background-position: -6.92rem 0;
                    }
                }
            }
        }
    }
}
</style>
